import * as React from 'react';
import { AppContext, AppContextType } from './AppContextType';
import { MainHandler } from './MainHandler';
import { Candidate } from './Model/Candidate';
import { JobVacancy } from './Model/JobVacancy';
import { ServiceLocator } from './ServiceLocator';

interface HandlerProps<M extends JobVacancy | Candidate> {
    handler: MainHandler<M>;
    serviceLocator: ServiceLocator;
    children: JSX.Element;
}

export class HandlerContextProvider<M extends JobVacancy | Candidate> extends React.Component<HandlerProps<M>> {
    public render() {
        const serviceLocator = this.props.serviceLocator;

        const appContext = new AppContext(
            serviceLocator,
            this.props.handler,
            serviceLocator.get('i18n'),
            serviceLocator.get('config')
        );

        return (
            <AppContextType.Provider value={appContext}>
                {this.props.children}
            </AppContextType.Provider>
        );
    }
}
